import React from 'react';
import { Placeholder, PlaceholderText } from '../ui/Placeholder';

export function ResourceManager() {
  return (
    <div className="space-y-6 h-full overflow-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Placeholder>
          <div className="bg-theme-bg-content rounded-lg shadow p-4">
            <h3 className="text-lg font-semibold mb-4 text-theme-text-primary">Production Schedule</h3>
            <div className="space-y-4">
              {[
                {
                  product: 'Quantum X Pro',
                  target: 5000,
                  completed: 3750,
                  status: 'on-track'
                },
                {
                  product: 'Nova Elite',
                  target: 4000,
                  completed: 2200,
                  status: 'delayed'
                },
                {
                  product: 'Nexus Lite',
                  target: 3500,
                  completed: 2800,
                  status: 'at-risk'
                }
              ].map((item, index) => (
                <div key={index} className="p-3 bg-theme-bg-secondary rounded-lg">
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="font-medium"><PlaceholderText text={item.product} /></h4>
                      <p className="text-sm text-theme-text-muted">
                        Target: <PlaceholderText text={`${item.target} units`} /> | Progress: <PlaceholderText text={`${item.completed} units`} />
                      </p>
                    </div>
                    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                      item.status === 'on-track' ? 'bg-theme-success/20 text-theme-success' :
                      item.status === 'delayed' ? 'bg-theme-error/20 text-theme-error' :
                      'bg-theme-warning/20 text-theme-warning'
                    }`}>
                      <PlaceholderText text={item.status} />
                    </span>
                  </div>
                  <div className="mt-2 w-full bg-theme-bg-tertiary rounded-full h-2">
                    <div
                      className={`h-2 rounded-full ${
                        item.status === 'on-track' ? 'bg-theme-success' :
                        item.status === 'delayed' ? 'bg-theme-error' :
                        'bg-theme-warning'
                      }`}
                      style={{ width: `${(item.completed / item.target) * 100}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Placeholder>

        <Placeholder>
          <div className="bg-theme-bg-content rounded-lg shadow p-4">
            <h3 className="text-lg font-semibold mb-4 text-theme-text-primary">Workforce Distribution</h3>
            <div className="space-y-4">
              {[
                {
                  name: 'Manufacturing',
                  employees: 500,
                  efficiency: 94,
                  utilization: 88,
                  skills: ['Assembly', 'Quality Control', 'Automation']
                },
                {
                  name: 'R&D',
                  employees: 250,
                  efficiency: 92,
                  utilization: 95,
                  skills: ['Hardware Design', 'Software Development', 'Innovation']
                },
                {
                  name: 'Supply Chain',
                  employees: 200,
                  efficiency: 90,
                  utilization: 85,
                  skills: ['Logistics', 'Inventory Management', 'Procurement']
                },
                {
                  name: 'Sales & Marketing',
                  employees: 300,
                  efficiency: 88,
                  utilization: 92,
                  skills: ['Sales', 'Digital Marketing', 'Market Analysis']
                }
              ].map((dept, index) => (
                <div key={index} className="p-3 bg-theme-bg-secondary rounded-lg">
                  <div className="flex justify-between mb-2">
                    <div>
                      <h4 className="font-medium"><PlaceholderText text={dept.name} /></h4>
                      <p className="text-sm text-theme-text-muted"><PlaceholderText text={`${dept.employees} employees`} /></p>
                    </div>
                    <div className="text-right">
                      <p className="font-medium"><PlaceholderText text={`${dept.efficiency}% efficiency`} /></p>
                      <p className="text-sm text-theme-text-muted"><PlaceholderText text={`${dept.utilization}% utilized`} /></p>
                    </div>
                  </div>
                  <div className="mt-2 flex gap-2">
                    {dept.skills.map((skill, skillIndex) => (
                      <span
                        key={skillIndex}
                        className="px-2 py-1 text-xs bg-theme-info/20 text-theme-info rounded-full"
                      >
                        <PlaceholderText text={skill} />
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Placeholder>
      </div>
    </div>
  );
}